import React from 'react';
import crossBorderedIcon from '../../../assets/cross-bordered-icon.svg';

const RoundedCloseIcon: React.FC = () => (
    <img src={crossBorderedIcon} title="Close" alt="Close" />
);

export default RoundedCloseIcon;
